// Pinned sections first, then the rest, each group in the order the app wrote them.
// Sections with no content are split out so they can be listed compactly.
export function arrangeSections(reportItems = []) {
  const withContent = reportItems.filter((item) => String(item.contents || '').trim() !== '');
  const empty = reportItems.filter((item) => String(item.contents || '').trim() === '');
  return {
    sections: [...withContent.filter((i) => i.pinned), ...withContent.filter((i) => !i.pinned)],
    empty,
  };
}
